import { PerspectivesReducerFn } from '../types';
import { streamReducer } from '@ardoq/rxbeach';
import {
  activeView$,
  ActiveViews,
} from 'streams/views/mainContent/activeView$';

const activeViewIdReducerFn: PerspectivesReducerFn<ActiveViews> = (
  state,
  { mainViewId }
) => ({
  ...state,
  activeViewId: mainViewId,
});

export const activeViewIdReducer = streamReducer(
  activeView$,
  activeViewIdReducerFn
);
